import * as React from 'react';
import {DragDropContext} from 'react-beautiful-dnd';

import type {SalesAutomationClosedLeadAutomation as SalesAutomationClosedLeadAutomationFragment} from 'nutshell-graphql-types';

import {ClosedLeadTaskTemplateContainer} from '../card-containers/closed-lead-task-template-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    closedLeadAutomations: SalesAutomationClosedLeadAutomationFragment[];
    isLoading: boolean;
    errorMessage: string | null | undefined;
};

export function ClosedLeadTasks(props: Props) {
    return (
        <DragDropContext onDragEnd={() => {}}>
            <CollapsibleSection type='closedLeadTaskTemplates'>
                <ClosedLeadTaskTemplateContainer
                    outcomeType='LEAD_WON'
                    isLoading={props.isLoading}
                    errorMessage={props.errorMessage}
                    closedLeadAutomations={props.closedLeadAutomations}
                />
                <ClosedLeadTaskTemplateContainer
                    outcomeType='LEAD_LOST'
                    isLoading={props.isLoading}
                    errorMessage={props.errorMessage}
                    closedLeadAutomations={props.closedLeadAutomations}
                />
                <ClosedLeadTaskTemplateContainer
                    outcomeType='LEAD_CANCELLED'
                    isLoading={props.isLoading}
                    errorMessage={props.errorMessage}
                    closedLeadAutomations={props.closedLeadAutomations}
                />
            </CollapsibleSection>
        </DragDropContext>
    );
}
